// extracted by mini-css-extract-plugin
export default {"Changes":"Changes_Changes__4DzIk","Content":"Changes_Content__H4gGj","List":"Changes_List__ZJaxZ"};